module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_eight-144b521cc9679b01fe639ce182351d8f.svg";